import { apiService } from '../api';
import { StatusLinkResponse, DocumentStanding } from '../../types/admissions';
import { FeeVoucherPrintSet } from '../../types/fees';

/**
 * Public, no-auth status link reader. Called by the parent-facing status
 * page (/status/:token). The one action a family takes themselves is
 * uploading the documents the school asked for.
 */
export const statusLinkService = {
  /** The applicant's private status page — track progress, pay, upload documents. */
  url: (statusToken: string): string =>
    `${window.location.origin}/status/${statusToken}`,

  getByToken: async (token: string): Promise<StatusLinkResponse> => {
    const r = await apiService.get<StatusLinkResponse>(`/public/status/${token}`);
    return r.data!;
  },

  /** One of this application's challans, for the voucher drawn in the browser. */
  getChallan: async (token: string, invoiceId: string): Promise<FeeVoucherPrintSet> => {
    const r = await apiService.get<FeeVoucherPrintSet>(`/public/status/${token}/challans/${invoiceId}`);
    return r.data!;
  },

  /** Upload one checklist document; returns the updated document list. */
  uploadDocument: async (token: string, key: string, file: File): Promise<DocumentStanding[]> => {
    const form = new FormData();
    form.append('key', key);
    form.append('admissionDocument', file);
    const r = await apiService.upload<DocumentStanding[]>(`/public/status/${token}/documents`, form);
    return r.data!;
  },
};
